<template>
    <div class="vertical-divider-settings">

        Vertical Divider Settings

    </div>
</template>

<script>


export default {
    name: 'VerticalDividerSettings',
    computed:{
        settingsFromWeebly() {
            return this.$store.state.verticaldividersettings
        }
    },
    mounted() {

    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/VerticalDividerSettings.vue